import React, { useState } from 'react';
import classnames from 'classnames';

type Props = {
  defaultEnablePositionSweeper: boolean,
  defaultSweeperNthBusinessDay: string,
  defaultSweeperExitHour: string,
  defaultSweeperExitMin: string,
  sweeperNthBusinessDayOptions: { value: string, label: string }[],
  sweeperNotBeforeHour: number,
  sweeperNotBeforeMin: number,
  sweeperNotAfterHour: number,
  sweeperNotAfterMin: number,
}

const PositionSweeperFields: React.FC<Props> = ({
  defaultEnablePositionSweeper,
  defaultSweeperNthBusinessDay,
  defaultSweeperExitHour,
  defaultSweeperExitMin,
  sweeperNthBusinessDayOptions,
  sweeperNotBeforeHour,
  sweeperNotBeforeMin,
  sweeperNotAfterHour,
  sweeperNotAfterMin,
}) => {
  const [enablePositionSweeper, setEnablePositionSweeper] = useState<boolean>(defaultEnablePositionSweeper);
  const [sweeperNthBusinessDay, setSweeperNthBusinessDay] = useState<string>(defaultSweeperNthBusinessDay);
  const [sweeperExitHour, setSweeperExitHour] = useState<string>(defaultSweeperExitHour);
  const [sweeperExitMin, setSweeperExitMin] = useState<string>(defaultSweeperExitMin);

  const notBefore = sweeperNotBeforeHour * 3600 + sweeperNotBeforeMin * 60;
  const notAfter = sweeperNotAfterHour * 3600 + sweeperNotAfterMin * 60;
  const isSweeperExitTimeValid = (() => {
    const hour = Number(sweeperExitHour);
    const min = Number(sweeperExitMin);
    const secondsSinceMidnight = hour * 3600 + min * 60;

    return secondsSinceMidnight >= notBefore && secondsSinceMidnight <= notAfter;
  })();

  return (<>
    <div className="form-check">
      <label className="form-check-label">
        <input className="form-check-input" type="checkbox"
          checked={enablePositionSweeper}
          onChange={() => { setEnablePositionSweeper(!enablePositionSweeper); }}
        />
        一定期間経過後のポジション強制決済を有効にする
      </label>
    </div>

    {enablePositionSweeper && <div className="input-group">
      <select
        onChange={(e) => {
          setSweeperNthBusinessDay(e.target.value);
        }}
        className="form-control"
      >
        {sweeperNthBusinessDayOptions.map(option => (
          <option
            key={option.value}
            value={option.value}
            selected={sweeperNthBusinessDay === option.value}
          >
            {option.label}
          </option>
        ))}
      </select>
      <span className="input-group-text">以上の保有で</span>
      <select
        onChange={(e) => {
          setSweeperExitHour(e.target.value);
        }}
        className={classnames('form-control', { 'is-invalid': !isSweeperExitTimeValid })}
      >
        {Array.from({ length: 24 }, (_, i) => i).map(hour => {
          if (hour < sweeperNotBeforeHour || hour > sweeperNotAfterHour) {
            return null;
          }
          const hourStr = hour.toString().padStart(2, '0');
          return (
            <option
              key={hourStr}
              value={hourStr}
              selected={sweeperExitHour === hourStr}
            >
              {hourStr}
            </option>
          );
        })}
      </select>
      <span className="input-group-text">:</span>
      <select
        onChange={(e) => {
          setSweeperExitMin(e.target.value);
        }}
        className={classnames('form-control', { 'is-invalid': !isSweeperExitTimeValid })}
      >
        {Array.from({ length: 60 }, (_, i) => i).map(min => {
          const minStr = min.toString().padStart(2, '0');
          return (
            <option
              key={minStr}
              value={minStr}
              selected={sweeperExitMin === minStr}
            >
              {minStr}
            </option>
          );
        })}
      </select>
      <span className="input-group-text">に決済</span>
    </div>}

    {enablePositionSweeper && <p className="mb-0">
      「1」営業日を指定した場合、決済時刻以降のエントリーは行ないません。
    </p>}

    {enablePositionSweeper ? <>
      <input type="hidden" name="subscription[enable_position_sweeper]" value="1" />
      <input type="hidden" name="subscription[sweeper_nth_business_day]" value={sweeperNthBusinessDay} />
      <input type="hidden" name="subscription[sweeper_exit_hour]" value={sweeperExitHour} />
      <input type="hidden" name="subscription[sweeper_exit_min]" value={sweeperExitMin} />
    </> : <>
      <input type="hidden" name="subscription[enable_position_sweeper]" value="0" />
    </>}
  </>);
};

export default PositionSweeperFields;